module.exports = __webpack_public_path__ + "img/tracer.0445c050.png";